// extracted by mini-css-extract-plugin
export var buttonContainer = "_5n-1";
export var fontSizeSelect = "_5n-3";
export var formatSelect = "_5n-2";
export var formats = "_5n-4";
export var hidden = "_5n-5";
export var icon = "_5n-6";
export var select = "_5n-0";